<template>
  <div class="qishangPage">
    <div class="topDiv">
      <h6 class="h6Text">请填写邮寄地址</h6>
    </div>
    <b-container fluid>
      <div>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-name">收货人</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="name"
              id="input-name"
              type="text"
              placeholder="请填写收货人姓名"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <b-row class="rowItem">
          <b-col cols="3">
            <label for="input-mobile">手机号</label>
          </b-col>
          <b-col cols="9">
            <b-form-input
              v-model="mobile"
              id="input-mobile"
              type="tel"
              maxlength="11"
              placeholder="请填写收货人手机号"
            ></b-form-input>
          </b-col>
        </b-row>
        <hr />
        <!-- 省市区选择 -->
        <b-row class="rowItem">
          <b-col cols="4">
            <b-form-select
              v-model="provinceText"
              :options="provinceS"
              size="sm"
            ></b-form-select>
          </b-col>
          <b-col cols="4">
            <b-form-select
              v-model="cityText"
              :options="cityS"
              size="sm"
            ></b-form-select>
          </b-col>
          <b-col cols="4">
            <b-form-select
              v-model="bankCode"
              :options="options"
              size="sm"
            ></b-form-select>
          </b-col>
        </b-row>
        <hr />
        <!-- <b-row class="rowItem">
          <b-col cols="3">
            <label>网点</label>
          </b-col>
          <b-col cols="9">
            <b-form-select
              v-model="wangdian"
              :options="wangdian_options"
            ></b-form-select>
          </b-col>
        </b-row> -->
        <b-row class="rowItem">
          <b-col cols="3">
            <label>详细地址</label>
          </b-col>
          <b-col cols="9">
            <van-field
              style="border: 1px solid #ccc; border-radius: 5px"
              v-model="detailAddress"
              rows="1"
              autosize
              type="textarea"
              maxlength="50"
              placeholder="请输入您的详细地址"
              show-word-limit
            />
            <!-- <b-form-input
              id="input-1"
              v-model="detailAddress"
              required
              rows="2"
              placeholder="请输入详细地址"
            ></b-form-input> -->
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="1">
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            />
          </b-col>
          <b-col>
            我已经阅读<font color="red" @click="showRules()"
              >《齐商银行DIY借记卡线上申请客户须知》</font
            >并同意相关内容。
            <!-- 我授权齐商银行将本人申请信息提供给齐商银行个性化定制卡业务合作方。 -->
          </b-col>
        </b-row>

        <b-row class="rowBtn">
          <b-col cols="10" class="mx-auto">
            <b-button
              :disabled="disabled"
              block
              variant="primary"
              @click="commitUserInfo()"
              >下一步</b-button
            >
          </b-col>
        </b-row>
        <b-row class="rowItemFee">
          <b-col style="font-size: 14px; color: #777777">
            温馨提示：<br />
            下一步将跳转至我行合作伙伴恒宝股份有限公司页面，进行图片上传、编辑及费用结算，相关责任由恒宝股份有限公司承担。
            <!-- 下一步将由我行合作伙伴恒宝股份有限公司对图片进行处理及卡片费用结算。 -->
          </b-col>
        </b-row>
      </div>

      <b-modal
        ref="rules"
        ok-only
        scrollable
        ok-title="确定"
        header-class="justify-content-center"
      >
        <template #modal-header>
          <div class="mx-auto">
            <span style="font-size: 16px; font-weight: bold"
              >齐商银行DIY借记卡线上申请客户须知</span
            >
          </div>
        </template>
        <div style="font-size: 12px; text-indent: 2em">
          <div>
            一、齐商银行DIY借记卡线上申请业务指客户通过齐商银行线上渠道申请指定卡种，并将预制的借记空白卡直邮申请人。
          </div>
          <div>
            二、齐商银行DIY借记卡线上申请业务实行“实名申请、预约开户”。您线上渠道申请成功后，印制成功的借记空白卡邮寄至您，但卡内不写入您的个人信息，卡片在您到网点办理开户前无法作为齐商银行借记卡账户使用。
          </div>
          <div>
            三、齐商银行DIY借记卡线上申请成功、卡片制作邮寄给您后，您需持申请时使用的身份证原件到营业网点办理开户，16周岁以下未成年人须监护人办理。
          </div>
          <div>
            四、您通过线上渠道申办齐商银行DIY借记卡时，须填写“姓名”“身份证码”“手机号”“邮寄地址”，DIY借记卡线上申请业务仅支持客户凭身份证件申请,申请时填写的姓名须与开户人一致。
          </div>
          <div>
            五、齐商银行DIY线上办卡申请纳入同一客户只可开立一个I类账户、4张实体借记卡的制度管理。若您持有我行实体借记卡数量超限，无法申请线上DIY借记卡。若您已持有我行I类账户实体卡，则本次申请卡片为II类账户。
          </div>
          <div>
            六、申请一经提交，相关信息不可修改，包括“姓名”“身份证号”“手机号”“邮寄地址”，以及个性化卡面业务所选卡面。
          </div>
          <div>
            七、出于制卡、服务等需要，您线上申请齐商银行DIY借记卡，即表示同意授权齐商银行将您的个人资料和信息披露给必要的第三方，范围仅限于该卡合作方、外包作业机构、增值服务提供方等。
          </div>
          <div>
            八、非质量原因无法更换为DIY借记卡，但可更换为齐商银行金达借记卡。
          </div>
          <div>
            九、对经核实不符合监管和齐商银行账户与借记卡管理规则的申请，齐商银行有权主动取消、解除服务。若已收取相关费用的，将退还至原账户。
          </div>
        </div>
      </b-modal>

      <b-modal
        ok-only
        ref="model_error"
        title="提示"
        @ok="handleOk"
        ok-title="确定"
      >
        <p>{{ errorMsg }}</p>
      </b-modal>

      <b-modal
        ref="model_bank_confirm"
        title="提示"
        @ok="handleBankConfirm"
        ok-title="确定"
        cancel-title="取消"
      >
        <p>
          尊敬的客户，请确认您持有我行个性化卡数量！如您没有我行个性化卡，可正常申请；
          如您持有超过4张（包含4张）个性化卡，想继续申请此卡片，在领取卡片及办理激活前，需将您至少一张存量卡片先销户。
        </p>
      </b-modal>

      <b-modal
        style="width: 80%"
        ref="model_user_info"
        hide-header-close
        @ok="handleUserInfo"
        content-class="shadow"
        ok-title="确定"
        cancel-title="取消"
      >
        <div style="font-size: 25px; text-align: center; margin-bottom: 10px">
          温馨提示：
        </div>
        <b-row>
          <b-col cols="12">
            <p style="color: #000; font-weight: 600; padding: 0 10px">
              <!-- 您填写的全部信息一经提交不可修改，请您在我行工作人员联系您领卡后，持申请使用的有效证件原件到我行营业网点办理开户后方可正常用卡。是否继续？ -->
              您填写的全部信息一经提交不可修改，请您在收到卡片后，持申请使用的有效证件原件到我行营业网点办理开户后方可正常使用。
              <!-- <br />如需咨询开卡事宜，可致电齐商银行客服热线：4006096588。 -->
            </p>
          </b-col>
        </b-row>
        <hr />
        <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 收货人： </b-col>
          <b-col cols="8">
            {{ name }}
          </b-col>
        </b-row>
        <hr />
        <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 手机号： </b-col>
          <b-col cols="8">
            {{ mobile }}
          </b-col>
        </b-row>
        <hr />
        <b-row style="padding: 0 10px">
          <b-col cols="4" style="color: #777777"> 邮寄地址： </b-col>
          <b-col cols="8" class="itemWordWrap">
            {{ address }}{{ detailAddress }}
          </b-col>
        </b-row>
      </b-modal>

      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">提交中</p>
        </div>
      </div>

      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
import { mobile_pattern } from "@/js/verifyData";
export default {
  name: "ApplyCard_qs",
  data() {
    return {
      status: "not_accepted",
      disabled: true, //是否可以下一步
      name: "",
      mobile: "", //当前页面用户输入的手机号码
      bankCode: null,
      address: null, //展示地址
      addressId: "", //接口上传地址id
      wangdian: null,
      messageData: "", //解密参数
      provinceText: null, //省id
      cityText: null, //市id
      detailAddress: "", //用户详细地址
      provinceS: [
        {
          value: null,
          text: "请选择省份",
        },
      ], //省
      //市
      cityS: [
        {
          value: null,
          text: "请选择市",
        },
      ],
      //区
      options: [
        {
          value: null,
          text: "请选择区",
        },
      ],
      //网点
      wangdian_options: [
        {
          value: null,
          text: "请选择网点",
        },
      ],
      errorMsg: "",
      loading: false,
      showToast: false,
      toastMsg: "",
    };
  },
  activated() {
    console.log("activated->");
    let paramsData = this.$route.params; //JSON.parse(.orderInfo);
    console.log("paramsData", paramsData);
    this.messageData = paramsData;
    console.log("activated messageData->" + JSON.stringify(this.messageData));

    this.name = "";
    this.mobile = "";
    this.bankCode = null; //区
    this.provinceText = null; //省id
    this.cityText = null; //市id
    this.wangdian = null;
    this.address = null;
    this.addressId = null;
    this.disabled = true;
    this.status = "not_accepted";
    this.detailAddress = "";
  },
  created() {},
  mounted: function () {
    console.log("mounted->");
    this.getProvinceList(); //获取省信息
  },
  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    //确定框
    handleUserInfo: function () {
      // this.$router.push({
      //   name: "SelectCardface_qs",
      //   params: {
      //     // ...this.messageData,
      //     // bankSerialNumber: bankSerialNumber,
      //     // bankCode: bankCode,
      //     // orderInfo: orderInfo, //this.$route.params.orderInfo
      //   },
      // });
      //提交事件
      this.getBankSn();
    },
    //获取省信息
    getProvinceList() {
      let param = new Object();
      param.parentId = "";
      let formData = new FormData();
      formData.append("parentId", param.parentId);
      console.log("param->" + JSON.stringify(param));

      axios.post(config.config_qs.getProvinceInfoList, formData).then((res) => {
        let that = this;
        let data = res.data;
        console.log(res);
        //{code: 110000, parent_id: 10000000, level_id: "1", name: "北京市", id: 10000001}
        var shengList = new Array(data.length + 1);
        var obj = new Object();
        obj.value = null;
        obj.text = "请选择省份";
        shengList[0] = obj;
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          let info = new Object();
          info.value = item.id;
          info.text = item.name;
          shengList[i + 1] = info;
        }
        that.provinceS = shengList;
      });
    },
    showUserInfo: function () {
      this.$refs["model_user_info"].show();
    },
    handleBankConfirm: function () {
      this.showUserInfo();
    },
    showBankConfirm: function () {
      this.$refs["model_bank_confirm"].show();
    },

    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    //网点获取
    getWangdian: function (bankCode) {
      var that = this;
      var formData = new FormData();
      formData.append("ascriptionCode", bankCode);
      axios
        .post(config.config_qs.getBranchInfoNewByParam, formData)
        .then(function (res) {
          console.log(res);
          let data = res.data;
          var wdList = new Array(data.length + 1);
          var obj = new Object();
          obj.value = null;
          obj.text = "请选择网点";
          wdList[0] = obj;
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let info = new Object();
            info.value = item.branch_code;
            info.text = item.branch_name;
            wdList[i + 1] = info;
          }
          that.wangdian_options = wdList;
        });
    },
    //查询支行信息
    queryBankInfo: function () {
      var that = this;
      axios
        .get(config.config_qs.queryBankBranchList, {
          params: {
            bankCode: config.config_qs.bankCode + "_", //
          },
        })
        .then(function (response) {
          console.log(response);
          let dataRes = response.data;
          if (dataRes.code != 0) {
            that.showToastMsg(dataRes.message);
            return;
          }
          let data = dataRes.bankList;
          var bankInfos = new Array(data.length + 1);
          var obj = new Object();
          obj.value = null;
          obj.text = "请选择分行";
          bankInfos[0] = obj;

          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let info = new Object();
            info.value = item.bankCode;
            info.text = item.bankName;
            bankInfos[i + 1] = info;
          }

          that.options = bankInfos;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //提交
    getBankSn: function () {
      var that = this;
      let orderInfo = that.$route.params.orderInfo;
      // let finalBankCode = this.bankCode + "_" + this.wangdian;
      let address = `${this.address}${this.detailAddress}`.replace(
        /\r|\n/gm,
        ""
      );
      let param = {
        clientName: this.name, //名称
        clientPhoneNumber: this.mobile, //手机号
        bankCode: config.config_qs.bankCode,
        bankSubCode: "", //分行编码
        bankBranchCode: this.wangdian, //支行|网点编码
        address: address, //邮寄地址拼接
        bankSerialNumber: this.messageData.flowNo, //卡唯一号
      };
      console.log(param);
      that.showLoading();
      axios
        .post(config.config_qs.qiShangSubmitUserInfo, param)
        .then(function (response) {
          // {code: 0, message: "交易成功", backSerialNumber: "2d506a29aaf846d3947ce1acfa9b38ad"}
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            //成功跳转页面
            that.toSelectCardFace(
              data.backSerialNumber,
              data.bankCode,
              orderInfo
            );
          } else {
            console.log("提交用户信息失败：" + data.message);
            that.errorMsg = data.message;
            that.showErrorMsg();
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
        });
    },
    //确定提交
    commitUserInfo: function () {
      const pattMobile = mobile_pattern;
      if (
        this.name.length == 0 ||
        this.name.length < 2 ||
        this.name.length > 15
      ) {
        this.showToastMsg("您输入的姓名长度不符合要求，请重新输入");
        return;
      }

      if (!pattMobile.test(this.mobile)) {
        this.showToastMsg("请输入正确的手机号");
        return;
      }
      if (this.provinceText == null) {
        this.showToastMsg("请选择省");
        return;
      }
      if (this.cityText == null) {
        this.showToastMsg("请选择市");
        return;
      }

      if (this.bankCode == null) {
        this.showToastMsg("请选择区");
        return;
      }

      if (this.detailAddress == "") {
        this.showToastMsg("请填写您的详细地址");
        return;
      }

      this.showUserInfo(); //确定信息
    },
    //提交成功跳转页面
    toSelectCardFace: function (bankSerialNumber, bankCode, orderInfo) {
      // console.log('this.$route.params', this.$route.params)
      //{checkStatus: "0", flowNo: "tsqs02", merchNo: "0085", mobileNo: "15810461602", name: "tsqs02"}
      this.messageData.flowNo = bankSerialNumber;
      this.messageData.name = this.name;
      this.messageData.merchNo = bankCode;
      this.messageData.mobileNo = this.mobile;
      console.log("messageData->", this.messageData);
      this.$router.replace({
        name: "SelectCardface_qs",
        params: {
          ...this.messageData,
          // bankSerialNumber: bankSerialNumber,
          // bankCode: bankCode,
          // orderInfo: orderInfo, //this.$route.params.orderInfo
        },
      });
    },
    showRules: function () {
      this.$refs["rules"].show();
    },
  },
  watch: {
    status: function (newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "accepted") {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    //监听网点
    wangdian: function (newval, oldval) {
      // console.log(
      //   "wangdian newval:" + newval + "," + "wangdian oldval:" + oldval
      // );
      let wangdian, brankCode;
      if (newval == null) {
      } else {
        this.wangdian_options.forEach((item, index) => {
          if (item.value == this.wangdian) {
            // console.log('item :>> ', item);
            wangdian = item.text;
            brankCode = item.value;
          }
        });
        let sheng, shi, qu;
        //省
        this.provinceS.forEach((item, index) => {
          if (item.value == this.provinceText) {
            sheng = item.text;
          }
        });
        //市
        this.cityS.forEach((item, index) => {
          if (item.value == this.cityText) {
            shi = item.text;
          }
        });
        // 区
        this.options.forEach((item, index) => {
          if (item.value == this.bankCode) {
            qu = item.text;
          }
        });
        this.address = `${sheng}${shi}${qu}${wangdian}`;
        this.addressId = `01B1_${this.provinceText}_${this.cityText}_${this.bankCode}_${brankCode}`; //`${this.addressId}_${brankCode}`;
        // console.log("this.addressId", this.addressId);
        // console.log("this.address", this.address);
      }
    },
    //监听区
    bankCode: function (newval, oldval) {
      if (newval == null) {
        this.wangdian = null;
        this.wangdian_options = [
          {
            text: "请选择网点",
            value: null,
          },
        ];
        return;
      } else {
        this.wangdian = null;
        // console.log("newval:" + newval + "," + "oldval:" + oldval);
        let sheng, shi, qu;
        //省
        this.provinceS.forEach((item, index) => {
          if (item.value == this.provinceText) {
            sheng = item.text;
          }
        });
        //市
        this.cityS.forEach((item, index) => {
          if (item.value == this.cityText) {
            shi = item.text;
          }
        });
        // 区
        this.options.forEach((item, index) => {
          if (item.value == this.bankCode) {
            qu = item.text;
          }
        });

        //详细地址
        this.address = `${sheng}${shi}${qu}`; //${wangdian}
        this.addressId = `01B1_${this.provinceText}_${this.cityText}_${this.bankCode}`; //_${this.wangdian}
        // console.log("this.addressId", this.addressId);
        // console.log("this.address", this.address);
        this.getWangdian(this.addressId);
      }
    },
    // 监听省下拉框
    provinceText: function (newval, oldval) {
      if (newval == null) {
        this.cityText = null;
        this.cityS = [
          {
            text: "请选择市",
            value: null,
          },
        ];
        return;
      } else {
        //获取市的数据
        this.cityText = null;
        var formData = new FormData();
        formData.append("parentId", newval);
        axios
          .post(config.config_qs.getCityInfoByParam, formData)
          .then((res) => {
            let that = this;
            let data = res.data;
            console.log(res);
            var shiList = new Array(data.length + 1);
            var obj = new Object();
            obj.value = null;
            obj.text = "请选择市";
            shiList[0] = obj;
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let info = new Object();
              info.value = item.id;
              info.text = item.name;
              shiList[i + 1] = info;
            }
            that.cityS = shiList;
          });
      }
    },
    //监听市下拉框
    cityText: function (newval, oldval) {
      if (newval == null) {
        this.bankCode = null;
        this.options = [
          {
            text: "请选择区",
            value: null,
          },
        ];
        return;
      } else {
        //获取区的数据
        this.bankCode = null;
        var formData = new FormData();
        formData.append("parentId", newval);
        axios
          .post(config.config_qs.getDistrictInfoByParam, formData)
          .then((res) => {
            let that = this;
            let data = res.data;
            console.log(res);
            var quList = new Array(data.length + 1);
            var obj = new Object();
            obj.value = null;
            obj.text = "请选择区";
            quList[0] = obj;
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let info = new Object();
              info.value = item.id;
              info.text = item.name;
              quList[i + 1] = info;
            }
            that.options = quList;
          });
      }
    },
  },
};
</script>

<style scoped>
.topDiv {
  height: 40px;
  width: 100%;
  background: #eee;
  color: red;
  margin-top: 0px;
}

.topDiv .h6Text {
  line-height: 40px;
  padding-left: 15px;
  font-size: 14px;
}

.colIntr {
  padding-left: 0;
  padding: 0 15px;
  color: red;
}

.rowItem {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.col-3 {
  padding-right: 0;
}

.rowItemFee {
  margin-top: 1rem;
}

.rowBtn {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.img {
  width: 100%;
}

.innerText {
  text-indent: 2rem;
}

.itemWordWrap {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/qishangbank/ApplyCard_qs.vue